import * as ProcessedWarranty from './processedWarranty';
import * as WarrantyReport from './warrantyReport';
import * as WarrantyInvoicing from './warrantyInvoicing';
import * as WarrantyErrorRate from './warrantyErrorRate';

const Actions = {
  ...ProcessedWarranty,
  ...WarrantyReport,
  ...WarrantyInvoicing,
  ...WarrantyErrorRate,
};

export default Actions;
